import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import LoadingCircular from "../../../loader/LoadingCircular";
import { getAllData } from "../../../Utils/firebaseServices";

function EmployeeAttendance() {
  const [userPortalData, setuserPortalData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getAllData("financeUserPortal", setuserPortalData);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return <LoadingCircular />;
  }

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <h1 className="hide">Employee Report</h1>

      <Table bordered>
        <thead>
          <tr>
            <th style={headerStyle}>Sr.n.</th>
            <th style={headerStyle}>Email</th>
            <th style={headerStyle}>Name</th>
            <th style={headerStyle}>Mobile No</th>
            <th style={headerStyle}>Status</th>
          </tr>
        </thead>
        <tbody>
          {userPortalData.length === 0 ? (
            <tr>
              <td colSpan={10} style={{ textAlign: "center" }}>
                No data available
              </td>
            </tr>
          ) : (
            userPortalData.map((item, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td style={{ textAlign: "center" }}>{item.email || "N/A"}</td>

                <td style={{ textAlign: "center" }}>{item.name || "N/A"}</td>
                <td style={{ textAlign: "center" }}>{item.mobilno || "N/A"}</td>
                <td style={{ textAlign: "center" }}>
                  <Link
                    to={`/attendance-day/${item.id}`}
                    style={{
                      color: "white",
                      padding: "6px 12px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      backgroundColor: "rgb(74, 127, 224)",
                      borderRadius: "6px",
                      textDecoration: "none",
                      display: "inline-block",
                    }}
                  >
                    Check Attendance
                  </Link>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}
const headerStyle = {
  backgroundColor: "black",
  color: "white",
  textAlign: "center",
};

export default EmployeeAttendance;
